import Decimal from "decimal.js"

export const changeDue = (cashCollected, total) =>
  new Decimal(cashCollected).sub(new Decimal(total)).toFixed(2)
